import requests from "@/utils/request";
import store from "@/store";

let request = requests.request;
let lang = store.state.isLang != "zh-CN" ? "en_en" : "zh_cn";

// 审计报告列表
export const getAuditReportList = (params) =>
  request.get("/auditProjects", { lang, params });

// 审计报告详情
export const getAuditReportDetail = (id) =>
  request.get(`/auditProjects/${id}`, { lang });

// 获取漏洞数据
export const getAuditProjectVulnera = (params) => {
  return request.get("/auditProjectVulnerabilities", { lang, params });
};

// 补充信息
export const upAuditProject = (id, data) => {
  return request.patch(`/auditProject/${id}`, { lang, ...data });
};

// 查询所有审计项目
export const getAllAuditProjects = () => {
  return request.get("/allAuditProjects", { lang });
};
